export default __webpack_public_path__ + "static/media/wi-day-snow.b0c0373e.svg";